import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';

function AddMembershipService() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    serviceId: '',
    membershipId: '',
    maxOrdersPerDay: '',
    maxDiscountPerOrder: '',
    discountPercent: ''
  });

  const [services, setServices] = useState([]);
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    fetchDropdownData();
  }, []);

  const fetchDropdownData = async () => {
    try {
      const serviceRes = await MembershipServiceListServices.getServiceGuest();
      const membershipRes = await MembershipServiceListServices.getMembershipGuest();
      const serviceData = serviceRes?.data || [];
      const membershipData = membershipRes?.data || [];
      const formattedServices = serviceData
        .filter(item => item.title)
        .map(item => ({
          _id: item._id,
          title: item.title
        }));

      setServices(formattedServices);
      setMemberships(membershipData);

      console.log("Services:", formattedServices);
      console.log("Memberships:", membershipData);

    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleNumberInput = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.serviceId || !formValues.membershipId) {
      alert("Please select Service and Membership");
      return;
    }

    try {
      const payload = {
      serviceId: formValues.serviceId,
        membershipId: formValues.membershipId,
        rules: {
          maxOrdersPerDay: Number(formValues.maxOrdersPerDay),
          maxDiscountPerOrder: Number(formValues.maxDiscountPerOrder),
          discountPercent: Number(formValues.discountPercent)
        }
      };

      console.log("Submitting payload:", payload);

      await MembershipServiceListServices.createMembershipService(payload);

      alert("Membership Service Created Successfully");
      navigate('/membership-service-list');

    } catch (error) {
      console.error("Create Error:", error);
      alert("Failed to create Membership Service " + (error.response?.data?.message || ""));
    }
  };

  return (
    <div className="right_col">
      <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
        <div className="my-auto">
          <h5 className="page-title fs-21 mb-1">Membership Service Add</h5>
        </div>
        <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
          <div className="pe-1 mb-xl-0">
            <Link className="list-banner-btn" to="/membership-service-list">
              Membership Service List
            </Link>
          </div>
        </div>
      </div>

      <div className="container-box">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>

              {/* ✅ Service Dropdown */}
              <div className="input-field">
                <label>Select Service *</label>
                <select
                  name="serviceId"
                  value={formValues.serviceId}
                  onChange={handleInputChange}
                  className="form-control"
       
                >
                  <option value="">Select Service</option>
                  {services.map(service => (
                    <option key={service._id} value={service._id}>
                      {service.title}
                    </option>
                  ))}
                </select>
              </div>

              {/* Membership Dropdown */}
              <div className="input-field">
                <label>Select Membership *</label>
                <select
                  name="membershipId"
                  value={formValues.membershipId}
                  onChange={handleInputChange}
                  className="form-control"
                                >
                  <option value="">Select Membership</option>
                  {memberships.map(mem => (
                    <option key={mem._id} value={mem._id}>
                      {mem.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Max Orders */}
              <div className="input-field">
                <label>Max Orders Per Day </label>
                <input
                  type="number"
                  name="maxOrdersPerDay"
                  value={formValues.maxOrdersPerDay}
                  onChange={handleInputChange}
                  onKeyDown={handleNumberInput}
                  className="form-control"
                  min="0"
              
                />
              </div>

              {/* Max Discount */}
              <div className="input-field">
                <label>Max Discount Per Order </label>
                <input
                  type="number"
                  name="maxDiscountPerOrder"
                  value={formValues.maxDiscountPerOrder}
                  onChange={handleInputChange}
                  onKeyDown={handleNumberInput}
                  className="form-control"
                  min="0"   
                />
              </div>

              {/* Discount Percent */}
              <div className="input-field">
                <label>Discount Percent </label>
                <input
                  type="number"
                  name="discountPercent"
                  value={formValues.discountPercent}
                  onChange={handleInputChange}
                  onKeyDown={handleNumberInput}
                  className="form-control"
                  min="0"
                  max="100"
                
                />
              </div>

              <button type="submit" className="submit-green-btn">
                SUBMIT
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMembershipService;